export const apiRoutes = {
  orders: '/orders',
  addOrder: '/orders/add',
  order: '/orders/:id',
  clients: '/clients',
  addClient: '/clients/add',
  client: '/clients/:id',
  leads: '/orders/leads',
  lead: '/leads/:id',
  tickets: '/tickets',
  users: '/users',
  sendInvite: '/users/send-invite',
  roles: '/roles',
  companies: '/companies',
  licensees: '/licensees',
  stages: '/stages',
  providers: '/providers',
  addProvider: '/providers/add',
  services: '/services',
  dsi: '/dsi',
  servicesTypes: '/servicetypes',
  addService: '/services/add',
  invites: '/invites',
  payors: '/payors',
  addPayor: '/payors/add',
  auth: '/auth',
  activities: '/activities',
  subscriptions: '/subscriptions',
  deposits: '/deposits',
  payments: '/payouts',
  goals: '/goals',
  addGoal: '/goals/add',
  vaultLinks: '/vaultlinks',
  salesStats: '/reports/salesStats',
  committedRevenue: '/reports/committedrevenue',
  companySummaries: '/reports/companysummary',
  companyServicesSummaries: '/reports/companyservicessummary',
  salesAttrition: '/reports/sales-attrition',
  utilityScorecard: '/reports/utility-scorecard',
  cancellationReasons: '/cancellationreasons',
  messageTemplatesOld: '/messages/templates',
  messageTemplates: '/messageTemplates',
  sendTextMessage: '/messages/send',
  messagingRules: '/messagingrules',
  enums: '/enums',
  frontierVerifyUser: '/energyproviders/frontierverifyuser',
  frontierConfirmEnrollment: '/energyproviders/frontierconfirmenrollment',
  frontierImportServices: '/energyproviders/frontierimportservices',
  frontierDateCheck: '/energyproviders/frontiercheckdates',
  rhythmVerifyUser: '/energyproviders/rhythmverifyuser',
  rhythmConfirmEnrollment: '/energyproviders/rhythmconfirmenrollment',
  rhythmImportServices: '/energyproviders/rhythmimportservices',
  rhythmDateCheck: '/energyproviders/rhythmcheckdates',
  tomorrowVerifyUser: '/energyproviders/tomorrowverifyuser',
  tomorrowConfirmEnrollment: '/energyproviders/tomorrowconfirmenrollment',
  tomorrowImportServices: '/energyproviders/tomorrowimportservices',
  tomorrowDateCheck: '/energyproviders/tomorrowcheckdates',
  gexaVerifyUser: '/energyproviders/gexaverifyuser',
  gexaConfirmEnrollment: '/energyproviders/gexaconfirmenrollment',
  gexaImportServices: '/energyproviders/gexaimportservices',
  gexaDateCheck: '/energyproviders/gexacheckdates',
  ohmConnectVerifyUser: '/energyproviders/ohmconnectverifyuser',
  ohmConnectConfirmEnrollment: '/energyproviders/ohmconnectconfirmenrollment',
  ohmConnectImportServices: '/energyproviders/ohmconnectimportservices',
  ohmConnectDateCheck: '/energyproviders/ohmconnectcheckdates',
  companyInitialText: '/messages/companyInitialText',
  testimonials: '/testimonials',
  ambitVerifyUser: '/energyproviders/ambitverifyuser',
  ambitConfirmEnrollment: '/energyproviders/ambitconfirmenrollment',
  ambitImportServices: '/energyproviders/ambitimportservices',
  companyImportMapping: '/companyimportmappings',
  referralSources: '/referralSources',
  ironHorseImportServices: '/energyproviders/ironhorseimportservices',
  varsityImportServices: '/energyproviders/varsityimportservices',
  ironHorseConfirmEnrollment: '/energyproviders/IronHorseConfirmEnrollmentAsync',
  varsityConfirmEnrollment: '/energyproviders/VarsityConfirmEnrollment',
  varsityVerifyUser: '/energyproviders/VarsityVerifyUser',
  varsityDataCheck: '/energyproviders/VarsityDataCheck',
  varsityWaivedReasons: '/energyproviders/VarsityDepositWaives',
  ringCentralClientIds: '/ringCentral/clientIds',
  quotes: '/quotes',
  spectrumImportServices: '/spectrum/importservices',
  research: '/research',
} as const;
